var Mobile;
(function (Mobile) {
    function checkConsent() {
        const prefix = currentUrlPrefix();
        if (prefix !== null && prefix !== undefined) {
            const newurl = prefix + "Account/SeeIfConsentBannerIsRequired";
            $.ajax({
                url: newurl,
                type: "GET",
                cache: true,
                success: (checkResponse) => {
                    if (checkResponse && checkResponse.BannerExists) {
                        displayBanner();
                    }
                },
                error: (xhr, status, error) => {
                    window.cobra.handlejqerr(xhr, status, error);
                },
            });
        }
    }
    Mobile.checkConsent = checkConsent;
    function displayBanner() {
        $("#divConsent").data("kendoMobileModalView").open();
    }
    function closeNoticeOfConsent() {
        $("#divConsent").data("kendoMobileModalView").close();
    }
    Mobile.closeNoticeOfConsent = closeNoticeOfConsent;
    function LoadHeader(productName, title, font, imageurl, hiddenTitle) {
        if (title.length > 0) {
            let encodedTitle = "";
            if (title.includes(";&#")) {
                const items = title.split(";");
                for (let i = 0; i < items.length; i++) {
                    items[i] = items[i].replace("&#", "");
                    if (items[i].includes(" ")) {
                        encodedTitle += " ";
                    }
                    encodedTitle += String.fromCharCode(parseInt(items[i]));
                }
            }
            else {
                encodedTitle = Main.htmlEncode(title);
            }
            if (!hiddenTitle && (font.length > 0 || imageurl.length > 0)) {
                const headerText = "<h3>" + encodedTitle + "</h3>";
                $("#bodyTitle").html(headerText);
            }
            document.title = encodedTitle;
        }
    }
    Mobile.LoadHeader = LoadHeader;
})(Mobile || (Mobile = {}));

//# sourceMappingURL=Mobile.js.map
